import styles from "./styles.module.scss";
import reusedStyles from "../styles.module.scss";

export default function Intro({ title, description }: { title: string, description: string }) {
	return (
		<div className={`${reusedStyles.section}`}>
			<div className={`container ${styles.container}`}>
				<h2 className={reusedStyles.heading}>{title}</h2>
				<div className={reusedStyles.paragraph} dangerouslySetInnerHTML={{ __html: description }} />
			</div>
		</div>
	);
}